import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { csmBaseUrlResource } from '@jira/router-resources__service-desk-customer-service-csm-base-url/src/csmBaseUrlResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsServiceHubsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsServiceHubsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { helpCenterSettingsServiceHubsRoutePageEntryPoint } from './ui/service-hubs/index.tsx';

export const helpCenterSettingsServiceHubsRouteEntry: Route = createEntry(
	helpCenterSettingsServiceHubsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.service-hubs',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () => helpCenterSettingsServiceHubsRoutePageEntryPoint,
		resources: [
			...getNavigationResources(),
			csmBaseUrlResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
